import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../pages/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {

  const { isAuthenticated, role } = useContext(AuthContext);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}